// extracted by mini-css-extract-plugin
export default {"advertCardFooter":"c-a_hw","advertCardFooter__row":"c-a_hx","advertCardFooter__name":"c-a_hy","advertCardFooter__price":"c-a_hz","advertCardFooter__age":"c-a_hA"};